import { useQuery } from "@tanstack/react-query";
import { APIClient } from "lib/api/client";
import { useCallback } from "react";
import { useAPIClient } from "render/context/APIContext";
import { useSession } from "render/context/MSALContext";

function getBookingTokensForPatient(apiClient: APIClient, patientId: string) {
  return apiClient.bookingV2
    .getBookingTokensForPatient({ patientId, availableForBooking: true })
    .result.then((value) => value.items);
}

function queryKey(patientId: string) {
  return ["booking-tokens", patientId];
}

export function useBookingTokens() {
  const { patientId } = useSession();
  const api = useAPIClient();
  const queryFn = useCallback(
    () => getBookingTokensForPatient(api, patientId),
    [api, patientId]
  );

  return useQuery({
    queryFn,
    queryKey: queryKey(patientId),
  });
}
